// VWO Event Tracking for Checkout Buttons
(function() {
  var VWO_EVENT_NAME = 'checkoutButtonClicked';
  
  // VWO reference code initialization (ensures VWO.event works correctly)
  window.VWO = window.VWO || [];
  window.VWO.event = window.VWO.event || function () {
    window.VWO.push(['event'].concat([].slice.call(arguments)));
  };
  
  function trackCheckoutButtonClick() {
    try {
      // Call VWO event exactly as documented
      window.VWO.event(VWO_EVENT_NAME);
      console.log('[VWO] Event fired:', VWO_EVENT_NAME);
    } catch (err) {
      console.error('[VWO] trackEvent error:', err);
    }
  }

  // Use delegated events from document - can't be removed by .off('click') on buttons
  $(document).ready(function() {
    $(document).on('click.vwoEventTracking', '[id^="VWO-checkout-button-"]', function() {
      trackCheckoutButtonClick();
    });
  });
})();

$(document).ready(function () {
  $(".hummenu_container").on("click", function () {
    $(".overlay").addClass("active");
    $("html").css("overflow", "hidden"); 
  });

  $(".overlay-close").on("click", function () {
    $(".overlay").removeClass("active");
    $("html").css("overflow", ""); 
  });

  const $checkoutButtons = $(".popUpBtn");
  const $directCheckoutButtons = $(".no-upsell-button");
  const $checkoutPopup = $("#checkoutPopup");
  const $proPlanPopup = $("#proPlanPopup");
  const $justMicButton = $(".just-mic-button");
  const $closePopupBtn = $("#closeBTn");
  const $closeProPlanBtn = $("#closeProPlanBtn");
  const $proPlanLabel = $(".Pro_plan_label");
  const $studioPlanLabel = $(".studio_plan_label");
  
  // Expose to global scope so VWO can access it
  window.currentVariantId = null;

  $checkoutButtons.on("click", function () {
    window.currentVariantId = $(this).data("variant-id");
    console.log("Variant set:", window.currentVariantId);
    if (!window.currentVariantId) {
      alert("Error: Missing product variant. Please refresh the page.");
      return;
    }
    $checkoutPopup.css("display", "flex");
  });

  $directCheckoutButtons.on("click", function () {
    window.currentVariantId = $(this).data("variant-id");
    console.log("Direct checkout variant set:", window.currentVariantId);
    if (!window.currentVariantId) {
      alert("Error: Missing product variant. Please refresh the page.");
      return;
    }
  });

  $proPlanLabel.on("click", function () {
    $checkoutPopup.hide();
    $proPlanPopup.css("display", "flex");
  });
  $studioPlanLabel.on("click", function () {
    $proPlanPopup.hide();
    $checkoutPopup.css("display", "flex");
  });

  $justMicButton.on("click", checkoutWithCurrentVariant);
  $directCheckoutButtons.on("click", checkoutWithCurrentVariant);

  async function checkoutWithCurrentVariant() {
    if (!window.currentVariantId) {
      alert("Please select a plan first.");
      return;
    }

    await clearCartBeforeAdd(); 
    addToCartAndCheckout(window.currentVariantId);
  }

  function clearCartBeforeAdd() {
    return fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then(() => console.log("Cart cleared before adding new product"))
      .catch((err) => console.warn("Cart clear failed before add", err));
  }

  function addToCartAndCheckout(variantId) {
    console.log("Adding to cart:", variantId);
    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      dataType: "json",
      data: {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      },
      success: function (response) {
        console.log("Cart response:", response);
        localStorage.setItem("goingToCheckout", "true");
        localStorage.setItem("checkoutStartedAt", String(Date.now()));
        window.location.href = "/checkout";
      },
      error: function (error) {
        console.error("Cart error:", error.responseJSON || error);
        alert(
          `Error: ${
            error.responseJSON?.description || "Could not add to cart."
          }`
        );
      },
    });
  }

  const AddOnPlusMainVariantAddToCart = (mainBtn) => {
    let finalProdForCart = [];
    const addOnVariantId = mainBtn.attr("data-sub-variant-id");
    const sellingPlanId = mainBtn.attr("data-selling-plan-id");
    const planName = mainBtn.attr("data-planName");

    if (!mainBtn.data("original-html")) {
      mainBtn.data("original-html", mainBtn.html());
    }

    mainBtn
      .empty()
      .html(`<span class="button is-loading is-loading--icon-only"></span>`)
      .addClass("focused");

    clearCartBeforeAdd().then(() => {
      finalProdForCart.push(
        {
          id: addOnVariantId,
          quantity: 1,
          selling_plan: sellingPlanId,
          // properties: { "Plan Name": planName },
          properties: {},
        },
        { id: window.currentVariantId, quantity: 1, properties: {} }
      );

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: finalProdForCart },
        dataType: "json",
        success: function () {
          localStorage.setItem("goingToCheckout", "true");
          localStorage.setItem("checkoutStartedAt", String(Date.now()));

          mainBtn.empty().html("Added").addClass("focused");

          setTimeout(() => {
            window.location.href = "/checkout";
          }, 1000);
        },
        error: function () {
          mainBtn
            .empty()
            .html(mainBtn.data("original-html"))
            .removeClass("focused");
        },
      });
    });
  };

  $closePopupBtn.on("click", () => $checkoutPopup.hide());
  $closeProPlanBtn.on("click", () => $proPlanPopup.hide());
  $(document).on("click", ".subscription_btn", function () {
    AddOnPlusMainVariantAddToCart($(this));
  });

  $(document).on("click", ".checkout", function () {
    localStorage.setItem("goingToCheckout", "true");
    localStorage.setItem("checkoutStartedAt", String(Date.now()));
  });

  const clearCartAfterCheckout = () => {
    if (localStorage.getItem("goingToCheckout") !== "true") return;

    const ref = document.referrer || "";
    const cameFromCheckout =
      ref.includes("/checkouts/") || ref.includes("/checkout");

    if (!cameFromCheckout) return;

    const startedAt = Number(localStorage.getItem("checkoutStartedAt") || 0);
    const within2Hours =
      startedAt && Date.now() - startedAt < 2 * 60 * 60 * 1000;
    if (!within2Hours) return;

    localStorage.removeItem("goingToCheckout");
    localStorage.removeItem("checkoutStartedAt");

    fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (res.ok) {
          if (typeof theme !== "undefined" && theme.cart?.getCart) {
            theme.cart.getCart();
          }
          console.log("Cart cleared after returning from checkout");
        }
      })
      .catch((err) => console.error("Error clearing cart after checkout:", err));
  };

  clearCartAfterCheckout();

  $closePopupBtn.on("click.preventReopen", function (e) {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(() => {
      $checkoutPopup.css("display", "flex");
      $("html").css("overflow", "hidden");
    }, 0);
  });
  $closeProPlanBtn.on("click.preventReopen", function (e) {
    e.preventDefault();
    e.stopPropagation();
    setTimeout(() => {
      $proPlanPopup.css("display", "flex");
      $("html").css("overflow", "hidden");
    }, 0);
  });

  $checkoutPopup.on("mousedown.dismissOutside", function (e) {
    if (e.target === this) {
      $(this).hide();
      $("html").css("overflow", "");
      popModalStateIfAny(); 
    }
  });
  $proPlanPopup.on("mousedown.dismissOutside", function (e) {
    if (e.target === this) {
      $(this).hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
  });

  $(document).on("mousedown.dismissOutsideDoc", function (e) {
    if ($checkoutPopup.is(":visible") && !$(e.target).closest("#checkoutPopup").length) {
      $checkoutPopup.hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
    if ($proPlanPopup.is(":visible") && !$(e.target).closest("#proPlanPopup").length) {
      $proPlanPopup.hide();
      $("html").css("overflow", "");
      popModalStateIfAny();
    }
  });

  $(document).on("keydown.dismissEsc", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      let closed = false;
      if ($checkoutPopup.is(":visible")) {
        $checkoutPopup.hide();
        closed = true;
      }
      if ($proPlanPopup.is(":visible")) {
        $proPlanPopup.hide();
        closed = true;
      }
      if (closed) {
        $("html").css("overflow", "");
        popModalStateIfAny();
      }
    }
  });

  let _activeModalKey = null; 

  function pushModalState(key) {
    if (_activeModalKey) return;
    try {
      history.pushState({ popup: key }, "", location.href);
      _activeModalKey = key;
    } catch (e) {}
  }

  function popModalStateIfAny() {
    if (!_activeModalKey) return;
    const key = _activeModalKey;
    _activeModalKey = null;
    try {
      history.back();
    } catch (e) {}
  }

  $checkoutButtons.on("click.historyHook", function () {
    setTimeout(() => {
      if ($checkoutPopup.is(":visible")) pushModalState("checkout");
    }, 0);
  });
  $proPlanLabel.on("click.historyHook", function () {
    setTimeout(() => {
      if ($proPlanPopup.is(":visible")) pushModalState("pro");
    }, 0);
  });
  $studioPlanLabel.on("click.historyHook", function () {
    setTimeout(() => {
      if ($checkoutPopup.is(":visible")) pushModalState("checkout");
    }, 0);
  });

  const mo = new MutationObserver(() => {
    const checkoutOpen = $checkoutPopup.is(":visible");
    const proOpen = $proPlanPopup.is(":visible");
    if (checkoutOpen && !_activeModalKey) pushModalState("checkout");
    else if (proOpen && !_activeModalKey) pushModalState("pro");
  });
  if ($checkoutPopup[0]) mo.observe($checkoutPopup[0], { attributes: true, attributeFilter: ["style", "class"] });
  if ($proPlanPopup[0]) mo.observe($proPlanPopup[0], { attributes: true, attributeFilter: ["style", "class"] });

  window.addEventListener("popstate", function () {
    if ($checkoutPopup.is(":visible") || $proPlanPopup.is(":visible")) {
      $checkoutPopup.hide();
      $proPlanPopup.hide();
      $("html").css("overflow", "");
      _activeModalKey = null;
      return;
    }
    if (_activeModalKey) _activeModalKey = null;
  });
});

// ========================================
// Audigo Country Selector Component
// ========================================
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('.country-selector__button'),
      closeButton: this.querySelector('.country-selector__close'),
      dropdown: this.querySelector('.country-selector__dropdown'),
    };
    
    this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
    this.elements.closeButton.addEventListener('click', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    
    this.querySelectorAll('.country-selector__link').forEach(item => {
      item.addEventListener('click', this.onItemClick.bind(this));
    });
    
    // Close on outside click
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target) && !this.elements.dropdown.hasAttribute('hidden')) {
        this.closeSelector();
      }
    });
  }

  toggleSelector() {
    const isHidden = this.elements.dropdown.hasAttribute('hidden');
    if (isHidden) {
      this.openSelector();
    } else {
      this.closeSelector();
    }
  }

  openSelector() {
    this.elements.dropdown.removeAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', 'true');
    this.elements.button.classList.add('is-open');
  }

  closeSelector() {
    this.elements.dropdown.setAttribute('hidden', '');
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.button.classList.remove('is-open');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.closeSelector();
      this.elements.button.focus();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

// Register the custom element
if (typeof customElements !== 'undefined' && !customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
